import { CoreLeagueLadderView } from '../../../../views';
import LadderTeamRow from '../LadderTeamRow';
import { Preloader } from '../../../../utils';
import { EmptyCompRowView } from '../LadderEmpty';
import Radio from 'backbone.radio';

const leagueLadderChannel = Radio.channel('league_ladder');
const globalChannel = Radio.channel( 'global' );

/**
 * @desc League CoreLeagueLadderView Class
 * This class using on comp ladder page ('comps/:comp_id/ladder')
 */
export class LadderTable extends CoreLeagueLadderView {
	get childView() {
		return LadderTeamRow;
	}

	get emptyView() {
		return EmptyCompRowView;
	}

	get default_limit() {
		return 50;
	}

	get default_offset() {
		return 0;
	}

	get childViewOptions() {
		return {
			...super.childViewOptions,
			tipping: this.tipping
		};
	}


	async initialize() {
		this.compTeams = this.getOption( 'compTeams' );
		this.comps     = this.getOption( 'comps' );
		this.tipping   = this.getOption( 'tipping' );

		await super.initialize();
	}

	initListeners() {
		this.listenTo( leagueLadderChannel, 'ladder:switch:table', this.updatePageData );
		this.listenTo( leagueLadderChannel, 'ladder:update', this.updatePageData );
		this.listenTo( leagueLadderChannel, 'ladder:sort:update', this.sortUpdate );
		this.listenTo( leagueLadderChannel, 'ladder:update:round', this.updatePageDataRound );
		this.listenTo( leagueLadderChannel, 'set:final:round', this.setFinalRound );
		this.listenTo( globalChannel, 'click:load:more', this.showMore );
		return this;
	}

	fetchData() {
		return this.rounds.fetch();
	}

	setFinalRound() {
		this.rounds.setFinalRound();
		this.updatePageData();
	}

	actualRound() {
		return this.rounds.points_round;
	}

	sendFetchData() {
		let data          = {
				id:              this.league_id,
				offset:          this.offset,
				type:            this.model.get('template_type'),
				limit:           this.limit,
				order:           this.model.get('order'),
				order_direction: this.model.get('order_direction')
			},
			template_type = this.model.get('template_type'),
			actual_round = this.actualRound();

		if(this.selected_round) {
			data = {
				...data,
				round: this.selected_round
			};
		}

		if ( this.model.get('current_round') ) {
			data.round = parseInt(this.model.get('current_round'), 10);
		}
		else if(actual_round) {
			data.round = actual_round.get('id');
		}
		// FINALS ROUNDS
		const is_final = [28,29,30,31].includes(data.round);

		if ( template_type === 'view-tips' ) {
			
			return Promise.all( [
				this.tipping.checkIsFinal(is_final).setMatchesUrl().getData({
					data: {
						round: this.model.get( 'current_round' )
					},
					type: 'user:tips'
				}),
				this.comps.showCompsTips( data )
			] );
		}
		else if ( template_type === 'streak' ) {
			let streak_data = {
				comp_id: this.league_id
			};

			if(this.selected_round) {
				streak_data = {
					...streak_data,
					round: this.selected_round
				};
			}

			return Promise.all( [
				this.compTeams
					.showStreakLadder(streak_data)
			] );
		}
		else {
			return Promise.all( [
				this.compTeams
					.showLeagueLadder( data )
			] );
		}
	}

	async updatePageDataRound(round) {
		Preloader.show();
		this.selected_round = round;
		this.offset = 0;
		this.limit = this.default_limit;
		await this.sendFetchData();
		this.render();
		Preloader.hide();
	}

	async updatePageData() {
		Preloader.show();
		await this.sendFetchData();
		this.updateCollection()
			.isShowMoreButton()
			.render();
		Preloader.hide();
	}

	sortUpdate( data ) {
		this.model.set( data );
		this.updatePageData();
	}

	updateCollection() {
		let status = this.model.get( 'status' ),
			template_type = this.model.get( 'template_type' );

		if( status === 'scheduled' ) {
			if( this.collection ) {
				this.collection.reset();
			}
		}
		else {
			this.collection = template_type === 'view-tips' ? this.comps : this.compTeams;
		}

		return this;
	}

	updateModel() {
		this.model.checkIsPossibleLeave();

		return this;
	}
}

export default LadderTable;